<template>
  <div class="category-manager">
    <div class="category-header">
      <el-link type="primary" :underline="false" class="category-title-btn" @click="$emit('open-dictionary-info')">属性字典</el-link>
      <el-link type="primary" :underline="false" @click="handleAddRoot">
        <i class="el-icon-circle-plus-outline"></i> 增加一级分类
      </el-link>
    </div>

    <div class="category-search">
      <el-select v-model="filterEnableFlag" placeholder="全部" size="small" style="width:80px;" @change="loadTree">
        <el-option label="全部" :value="null"></el-option>
        <el-option label="启用" :value="true"></el-option>
        <el-option label="禁用" :value="false"></el-option>
      </el-select>
      <el-input v-model="filterName" placeholder="搜索分类" size="small" style="flex:1;margin-left:4px;">
        <i slot="suffix" class="el-icon-search" style="line-height:32px;margin-right:4px;"></i>
      </el-input>
    </div>

    <el-tree
      ref="categoryTree"
      :data="treeData"
      node-key="id"
      :props="{ children: 'children', label: 'name' }"
      :highlight-current="true"
      :expand-on-click-node="false"
      default-expand-all
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
      class="category-tree"
    >
      <span slot-scope="{ node, data }" class="tree-node" :class="{ 'is-disabled': !data.enableFlag }">
        <span class="tree-node-label" :title="data.name">{{ data.name }}</span>
        <span v-if="data.enableFlag" class="tree-node-actions">
          <i class="el-icon-circle-plus-outline node-icon" title="新增子分类" @click.stop="handleAddChild(data)"></i>
          <i class="el-icon-edit-outline node-icon" title="编辑" @click.stop="handleEdit(data)"></i>
          <i class="el-icon-delete-solid node-icon node-icon-delete" title="删除" @click.stop="handleDelete(data)"></i>
        </span>
      </span>
    </el-tree>

    <!-- 新增/编辑分类弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :model="form" :rules="rules" ref="categoryForm" label-width="80px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="10" show-word-limit placeholder="请输入分类名称（最多10字）"></el-input>
        </el-form-item>
        <el-form-item label="分类描述">
          <el-input v-model.trim="form.description" maxlength="50" show-word-limit placeholder="请输入分类描述（最多50字）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAttributeCategoryTree,
  addAttributeCategory,
  updateAttributeCategory,
  deleteAttributeCategory,
} from '@/api/PlatformSales/AttributeCategory';

export default {
  name: 'AttributeCategoryManager',
  data () {
    return {
      treeData: [],
      filterName: '',
      filterEnableFlag: null,
      dialogVisible: false,
      dialogTitle: '新增分类',
      form: {
        id: null,
        name: '',
        description: '',
        parentId: null,
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: ['blur', 'change'] }],
      },
    };
  },
  watch: {
    filterName (val) {
      this.$refs.categoryTree && this.$refs.categoryTree.filter(val);
    },
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.includes(value);
    },
    loadTree (autoSelectFirst = false) {
      getAttributeCategoryTree({ enableFlag: this.filterEnableFlag }).then(({ body }) => {
        this.treeData = body || [];
        if (autoSelectFirst && this.treeData.length > 0) {
          const first = this.treeData[0];
          this.$nextTick(() => {
            this.$refs.categoryTree && this.$refs.categoryTree.setCurrentKey(first.id);
          });
          this.$emit('category-change', first);
        }
      });
    },
    handleNodeClick (data) {
      this.$emit('category-change', data);
    },
    handleAddRoot () {
      this.form = { id: null, name: '', description: '', parentId: null };
      this.dialogTitle = '新增一级分类';
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.categoryForm && this.$refs.categoryForm.clearValidate());
    },
    handleAddChild (parentData) {
      this.form = { id: null, name: '', description: '', parentId: parentData.id };
      this.dialogTitle = `新增「${parentData.name}」的子分类`;
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.categoryForm && this.$refs.categoryForm.clearValidate());
    },
    handleEdit (data) {
      this.form = { id: data.id, name: data.name, description: data.description || '', parentId: data.parentId };
      this.dialogTitle = '编辑分类';
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.categoryForm && this.$refs.categoryForm.clearValidate());
    },
    handleDelete (data) {
      this.$confirm(`确定要删除分类「${data.name}」吗？`, '删除分类', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAttributeCategory({ id: data.id }).then(() => {
          this.$message.success('删除成功');
          this.loadTree();
          this.$emit('category-change', null);
        });
      });
    },
    handleSubmit () {
      this.$refs.categoryForm.validate((valid) => {
        if (!valid) return;
        const api = this.form.id ? updateAttributeCategory : addAttributeCategory;
        api({ ...this.form }).then(() => {
          this.$message.success(this.form.id ? '更新成功' : '新增成功');
          this.dialogVisible = false;
          this.loadTree();
        });
      });
    },
  },
  created () {
    this.loadTree(true);
  },
};
</script>

<style scoped lang="scss">
.category-manager {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-right: 1px solid #DFE2E8;
  padding: 0 4px;
}

.category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.category-title-btn {
  font-size: 14px;
  font-weight: 600;
}

.category-search {
  display: flex;
  align-items: center;
  padding: 0 8px 8px;
}

.category-tree {
  flex: 1;
  overflow-y: auto;
  font-size: 13px;
}

.tree-node {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

.tree-node-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tree-node-actions {
  display: flex;
  align-items: center;
  margin-left: 4px;
  flex-shrink: 0;
}

.node-icon {
  font-size: 14px;
  color: #d3d3d3;
  cursor: pointer;
  margin-left: 4px;

  &:hover {
    color: #409EFF;
  }

  &.node-icon-delete:hover {
    color: #F56C6C;
  }
}

/deep/ .el-tree-node.is-current > .el-tree-node__content {
  background: rgba(15, 137, 255, 0.08);
  border-radius: 4px;
}

.tree-node.is-disabled .tree-node-label {
  color: #C0C4CC;
}

</style>
